import React from "react";
import { AlertOctagon, Zap, Droplet, Ban, HeartOff } from "lucide-react";

// 5 care flag definitions with colors and icons
export const CARE_FLAG_META = {
  falls_risk:   { label: "Falls Risk",         color: "bg-red-100 text-red-800 border-red-300",         Icon: AlertOctagon, dot: "🟥" },
  epilepsy:     { label: "Epilepsy",           color: "bg-orange-100 text-orange-800 border-orange-300", Icon: Zap,          dot: "🟧" },
  diabetes:     { label: "Diabetes",           color: "bg-violet-100 text-violet-800 border-violet-300", Icon: Droplet,      dot: "🟪" },
  choking_risk: { label: "Choking Risk",       color: "bg-amber-100 text-amber-800 border-amber-300",   Icon: Ban,          dot: "🟨" },
  dnr:          { label: "DNR",                color: "bg-sky-100 text-sky-800 border-sky-300",         Icon: HeartOff,     dot: "🔵", full: "Do Not Resuscitate" },
};

export const CARE_FLAG_ORDER = ["falls_risk", "epilepsy", "diabetes", "choking_risk", "dnr"];

export default function CareFlagsPills({ flags, size = "md" }) {
  if (!flags || flags.length === 0) return null;
  const ordered = CARE_FLAG_ORDER.filter((k) => flags.includes(k));
  const sz = size === "sm" ? "text-[10px] py-0.5 px-1.5" : "text-xs py-1 px-2";
  const iconSz = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5";
  return (
    <div className="inline-flex items-center gap-1.5 flex-wrap" data-testid="care-flags-pills">
      {ordered.map((k) => {
        const m = CARE_FLAG_META[k];
        const Icon = m.Icon;
        return (
          <span
            key={k}
            className={`inline-flex items-center gap-1 font-semibold uppercase tracking-widest border ${m.color} ${sz}`}
            title={m.full || m.label}
            data-testid={`care-flag-${k}`}
          >
            <Icon className={iconSz} strokeWidth={2.25} />
            {m.label}
          </span>
        );
      })}
    </div>
  );
}
